// extracted by mini-css-extract-plugin
export default {"input":"myinput_input__noJYV"};